export default {
  data: () => ({
    templateNumberNameRules: [
      (v) => !!v || 'กรุณากรอกชื่อชุด',
    ],
    templateNumberTypeRules: [
      (v) => !!(v || {}).id || 'กรุณาเลือกชุดตัวเลข',
    ],
    templateNumberValueRules: [
      (v) => !!v || 'กรุณากรอกตัวเลข',
    ],
    phoneNumberRules: [
      (v) => !!v || 'กรุณากรอกเบอร์โทรศัพท์',
      (v) => !/\s/.test(v) || 'เบอร์โทรศัพท์ไม่ควรมีช่องว่าง',
      (v) =>
        (v && v.length === 10) || 'เบอร์โทรศัพท์ควรมีความยาว 10 ตัวอักษร',
    ],
    bankRules: [
      (v) => !!v || 'กรุณาเลือกธนาคาร',
    ],
    accountNumberRules:[
      (v) => !!v || 'กรุณากรอกเลขบัญชี',      
      (v) => (v && v.length <= 15 && v.length >= 10) || 'เลขบัญชีควรมีความยาว 10-15 ตัว',
    ],
    accountNameRules: [
      (v) => !!v || 'กรุณากรอกชื่อเจ้าของบัญชี',
      (v) => (v && v.length <= 50) || 'ชื่อเจ้าของบัญชีไม่ควรเกิน 50 ตัวเลข',
    ],
    accountBanknameRules: [
      (v) => !!v || 'กรุณากรอกชื่อบัญชี',
      (v) => (v && v.length >= 10) || 'ชื่อบัญชีควรมีความยาว 10 ตัวขึ้นไป',
    ],
    accountFirstNameRules: [
      (v) => !!v || 'กรุณากรอกชื่อเจ้าของบัญชี',
      (v) => !/\s/.test(v) || 'ชื่อเจ้าของบัญชีไม่ควรมีช่องว่าง',
      (v) => (v && v.length <= 50) || 'ชื่อเจ้าของบัญชีไม่ควรเกิน 50 ตัวเลข',
    ],
    accountLastNameRules: [
      (v) => !!v || 'กรุณากรอกนามสกุลเจ้าของบัญชี',
      (v) => !/\s/.test(v) || 'นามสกุลเจ้าไม่ควรมีช่องว่าง',
      (v) => (v && v.length <= 50) || 'นามสกุลเจ้าของบัญชีไม่ควรเกิน 50 ตัวเลข',
    ],
    firstNameRules: [
      (v) => !!v || 'กรุณากรอกชื่อ',
      (v) => !/\s/.test(v) || 'ชื่อไม่ควรมีช่องว่าง',
      (v) => (v && v.length <= 50) || 'ความยาวของชื่อไม่ควรเกิน 50 ตัวอักษร',
    ],
    lastNameRules: [
      (v) => !!v || 'กรุณากรอกนามสกุล',
      (v) => !/\s/.test(v) || 'นามสกุลไม่ควรมีช่องว่าง',
      (v) => (v && v.length <= 100) || 'ความยาวของชื่อไม่ควรเกิน 100 ตัวอักษร',
    ],
    emailRules: [
      // (v) => !!v || 'กรุณากรอกอีเมลล์',
      (v) => (!v || /.+@.+\..+/.test(v)) || 'กรุณากรอกอีเมลล์ให้ถูกต้อง',
      (v) => !/\s/.test(v) || 'อีเมลล์ไม่ควรมีช่องว่าง',
      (v) => (!v || v.length <= 255) || 'ความยาวของอีเมลล์ไม่ควรเกิน 255 ตัวอักษร',
    ],
    lineRules: [
      // (v) => !!v || 'กรุณากรอกไลน์',      
      (v) => !/\s/.test(v) || 'ไลน์ไม่ควรมีช่องว่าง',
      (v) => (!v || v.length <= 100) || 'ความยาวของไลน์ไม่ควรเกิน 100 ตัวอักษร',
    ],
    dateRules: [
      (v) => !!v || 'กรุณากรอกวันเกิด',
    ],
    otpRules: [
      (v) => !!v || 'กรุณากรอกรหัสยืนยัน',
      (v) => !/\s/.test(v) || 'รหัสยืนยันไม่ควรมีช่องว่าง',
      (v) => (v && v.length === 4) || 'รหัสยืนยันไม่ถูกต้อง',
    ],
    userNameLoginRules: [v => !!v || 'กรุณากรอกชื่อผู้ใช้'],
    userNameRules: [
      (v) => !!v || 'กรุณากรอกชื่อผู้ใช้',
      (v) =>
        (v && v.length >= 6) || 'ชื่อผู้ใช้ควรมีความยาวมากกว่า 6 ตัวอักษร',
      (v) =>
        (v && v.length <= 50) || 'ชื่อผู้ใช้ห้ามมีความยาวมากกว่า 50 ตัวอักษร',
    ],
    passwordLoginRules: [v => !!v || 'กรุณากรอกรหัสผ่าน'],
    passwordResetRules: [
      (v) => !!v || 'กรุณากรอกรหัสผ่าน',
      (v) =>
        (v && v.length >= 5) || 'รหัสผ่านควรมีความยาวมากกว่า 5 ตัวอักษร',

      (v) => (v && v.length <= 20) || 'รหัสผ่านห้ามมีความยาวมากกว่า 20 ตัวอักษร',
    ],
    passwordRules: [
      (v) => !!v || 'กรุณากรอกรหัสผ่าน',
      (v) =>
        (v && v.length >= 8) || 'รหัสผ่านควรมีความยาวมากกว่า 8 ตัวอักษร',

      (v) => (v && v.length <= 20) || 'รหัสผ่านห้ามมีความยาวมากกว่า 20 ตัวอักษร',
    ],
    messageRules: [
      v => !!v || 'กรุณาใส่รายละเอียด'
    ],
  }),
  computed: {
    confirmPasswordRules () {
      return this.passwordRules.concat(
        (v) => v === this.form.new_password || 'รหัสผ่านไม่ตรงกัน'
      )
    },
  },
}
